/**
 * @Author:
 * @Description:
 * @DateTime: Created in 23:01 2020/10/11
 */
import * as Vue from "vue-tsx-support";
import {Component, Prop, Emit,Watch} from 'vue-property-decorator'
import "vue-tsx-support/enable-check"
import EnumEntity from "../../enums/enumEntity";
import CommonSelect from "./commonSelect";
import StationConfigApi from 'src/pages/systemConfig/stationConfig/api/stationConfigApi';
import UserConfigApi from 'src/pages/systemConfig/userConfig/api/userConfigApi';
import EnumItem from 'src/enums/enumItem';
import EnumUserStatus from 'src/enums/enumUserStatus';
import RoleConfigApi from 'src/pages/systemConfig/roleConfig/api/roleConfigApi';
import SaasAccountConfigApi from 'src/pages/saasAccountConfig/api/saasAccountConfigApi';
import OperationLogApi from 'src/pages/stationDetail/component/operationLog/api/operationLogApi';
import StationListApi from 'src/pages/stationList/api/stationListApi';
import DeclareMaintenanceApi from 'src/pages/maintenanceManage/declareMaintenance/api/declareMaintenanceApi';
import CompareNoticeApi from 'src/pages/maintenanceManage/compareNotice/api/compareNoticeApi';
import DataManagementApi from 'src/pages/fileConfig/dataManagement/api/dataManagementApi';
import VideoApi from 'src/pages/systemConfig/video/api/videoApi';
import DiskConfigApi from 'src/pages/systemConfig/diskConfig/api/diskConfigApi';

export interface EntitySelectPropsI {
	type: number
	value?: number|null|Array<number|null>
	clearable?: boolean
	filterable?: boolean
	readonly?: boolean
	multiple?: boolean
	disabled?: boolean
	transfer?: boolean
	useNameAsId?: boolean
    placeholder?: string
    searchParams?: any
}

export interface EnumSelectEventI {
	onInput (value: number): void

	onChange (item: {value: number, label: string}|number): void
}

const CONFIG:any = {

    [EnumEntity.Basin.getId()]: { title: '流域', ajax: StationConfigApi.queryBasin, defaultParams: { page_index: 1, page_size:1000000}, dataField: 'data_info'},
    [EnumEntity.Agreement.getId()]: { title: '协议', ajax: StationConfigApi.queryAgreement, defaultParams: { page_index: 1, page_size:1000000}, dataField: 'data_info'},
    [EnumEntity.Measuring.getId()]: { title: '测量类型', ajax: StationConfigApi.queryMeasuring, defaultParams: { page_index: 1, page_size:1000000}, dataField: 'data_info'},
    [EnumEntity.ComponentProduct.getId()]: { title: '因子组', ajax: StationConfigApi.queryComponentProduct, defaultParams: { page_index: 1, page_size:1000000}, dataField: 'data_info'},
    [EnumEntity.Organization.getId()]: { title: '组织', ajax: UserConfigApi.queryAllOrganization},
    [EnumEntity.User.getId()]: { title: '用户', ajax: UserConfigApi.searchList, defaultParams: {status: EnumUserStatus.Normal.getId()}, dataField: 'data_info',transfar: {name: 'real_name'}},
    [EnumEntity.Role.getId()]: { title: '角色', ajax: RoleConfigApi.searchList,  dataField: 'data_info',transfar: {name: 'role_name'}},
    [EnumEntity.Saas.getId()]: { title: 'Saas', ajax: SaasAccountConfigApi.querySaasList,  transfar: {name: 'real_name', id: 'enterprise_id'}},
    [EnumEntity.Component.getId()]: { title: '组分', ajax: OperationLogApi.searchSiteComponent,  transfar: {id: 'key'}},
    [EnumEntity.Station.getId()]: { title: '站点', ajax: StationListApi.searchDeviceList, defaultParams: { page_index: 1, page_size:1000000}, dataField: 'data_info'},
    [EnumEntity.DeclareType.getId()]: { title: '申报类型', ajax: DeclareMaintenanceApi.searchDeclareTypeList, defaultParams: { page_index: 1, page_size:1000000}, dataField: 'data_info',transfar: {name: 'declare_type'}},
    [EnumEntity.ComponentById.getId()]: { title: '申报类型', ajax: DeclareMaintenanceApi.searchComponentsById,transfar: {id: 'component_id'}},
    [EnumEntity.Company.getId()]: { title: '处理单位', ajax: CompareNoticeApi.getCompany,transfar: {name: 'account_name'}},
	[EnumEntity.DataManagement.getId()]: { title: '资料类别', ajax: DataManagementApi.searchDataCategoriesById, transfar: {name: 'data_name', id: 'id'}},
	[EnumEntity.VideoKey.getId()]: { title: '视频密钥', ajax: VideoApi.searchVideoKey, defaultParams: { page_index: 1, page_size:1000000}, dataField: 'data_info'},
    [EnumEntity.NvrInfo.getId()]: { title: 'NVR信息', ajax: DiskConfigApi.deviceIdByNvr, defaultParams: {}, dataField: 'data_info'},
    [EnumEntity.ComponentDetails.getId()]: { title: '因子组详情', ajax: StationConfigApi.queryComponentProductDetails, defaultParams: {}, dataField: 'data_info'},

}

@Component
export default class EntitySelect extends Vue.Component<EntitySelectPropsI, EnumSelectEventI> {
	@Prop({
		type: Boolean,
		default: false
	})
    multiple!: boolean
    
    @Prop({
		type: Boolean,
		default: false
	})
	useNameAsId!: boolean

	@Prop({
		type: Boolean,
		default: false
	})
	disabled!: boolean

	@Prop({
		type: Boolean,
		default: true
	})
	filterable!: boolean

	@Prop({
		type: Boolean,
		default: false
	})
	readonly!: boolean

	@Prop({
		type: Boolean,
		default: true
	})
	transfer!: boolean

	@Prop({
		type: Boolean,
		default: true
	})
	clearable!: boolean

	@Prop({
		type: Number
	})
    type!: number
    
    @Prop({
		type: Object
	})
	searchParams!: any

	@Prop({
		type: [Number, Array]
	})
    value!: number|null|string|Array<number|null|string>
    
    get dataSource() {
        let transfar = CONFIG[this.type].transfar
        if(!transfar) {
            return this.sourceData
        } else {
           return this.sourceData.map((i) => {
                let o = {
                    code: transfar.code ? i[transfar.code] : i.code,
                    id: transfar.id ? i[transfar.id] : (i.id || i.code),
                    name: transfar.name ? i[transfar.name] : i.name
                }
                return o
            })
        }
    }

    get dataSourceRes() {
        return this.dataSource.map(i=> ({
            name: i.name,
            id: this.useNameAsId?i.name: i.id
        }))
    }


	@Emit('input')
	input (value: number) {
		return value
	}

	@Emit('change')
	change (item: {value: number|string, label: string}|number|string) {
		return item
	}

	@Emit('clear')
    clear (value: number) {}

    @Watch('searchParams')
    searchParamsChange(newVal, oldVal) {
       if( JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
           this.search()
       }
    }
    
    ajaxPromise:any

    sourceData:any = []

	get defaultPlaceholder () {
		let str = EnumEntity.findId(this.type).getName()
		return `请选择${str}`
    }
    
    async search() {
        let { code, data } = await CONFIG[this.type].ajax({...(CONFIG[this.type].defaultParams||{}), ...(this.searchParams||{})}) 
        if (code === 0) {
            let dataField = CONFIG[this.type].dataField
            if(dataField) {
                data = data[dataField]
            }
            this.sourceData = data||[]
        } 
    }

	async mounted () {
		this.search()
    }
    
    getDataSource():Array<EnumItem> {
        return this.dataSource
    }

    getSourceData():Array<any> {
        return this.sourceData
    }

	render (h) {
		return (
			<CommonSelect
				filterable={this.filterable}
				transfer={this.transfer}
				class={{'wqms-select-readonly': this.readonly}}
				placeholder={this.defaultPlaceholder}
				clearable={this.clearable}
				disabled={this.disabled|| this.readonly}
				on-input={this.input}
				value={this.value}
				on-change={this.change}
				on-clear={this.clear}
				dataSource={this.dataSourceRes}
				multiple={this.multiple}>

			</CommonSelect>
		)
	}
}
